import { toRefs, shallowReactive } from 'vue';
import i18n from '@/i18n';
const { t } = i18n.global;

export enum AutoSyncStatus {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  LOADING = 'LOADING',
}

interface AutoSyncState {
  visible: boolean;
  title?: string;
  subtitle?: string;
  status: `${AutoSyncStatus}`;
}

const defaultState: AutoSyncState = {
  visible: false,
  status: AutoSyncStatus.LOADING,
  title: t('AUTO_SYNC.TITLE.DEFAULT'),
  subtitle: t('AUTO_SYNC.SUBTITLE.DEFAULT'),
};

const state = shallowReactive<AutoSyncState>(defaultState);

const setNewStatus = (newStatus: `${AutoSyncStatus}`) => {
  state.status = newStatus;
  state.visible = true;
};

export default () => ({
  ...toRefs(state),
  setNewStatus,
});
